import { Link } from "react-router-dom";
import { formatDate } from "@/lib/api";

export const PostCard = ({ post, className = "" }) => (
  <Link to={`/logbook/${post.slug}`} className={`group block ${className}`} data-testid={`post-card-${post.slug}`}>
    <div className="relative aspect-[4/3] overflow-hidden rounded-2xl border border-white/[0.08] bg-ink-3">
      {post.image && (
        <img src={post.image} alt="" loading="lazy" className="h-full w-full object-cover grayscale-[60%] transition-[transform,filter] duration-[1200ms] ease-out group-hover:scale-[1.05] group-hover:grayscale-0" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
      {post.categories?.[0] && <span className="absolute left-3 top-3 rounded-full bg-ink/70 px-3 py-1 mono text-[11px] uppercase tracking-[0.12em] text-fg backdrop-blur">{post.categories[0]}</span>}
    </div>
    <p className="mono mt-4 text-[12px] uppercase tracking-[0.12em] text-fg-3">{formatDate(post.published)} · {post.reading_minutes ?? 1} min</p>
    <h3 className="mt-2 text-xl font-[540] leading-snug tracking-[-0.02em] text-fg transition-colors group-hover:text-signal">{post.title}</h3>
    {post.subtitle && <p className="mt-2 line-clamp-2 text-[14px] leading-relaxed text-fg-2">{post.subtitle}</p>}
  </Link>
);

export const PostSkeleton = () => (
  <div className="animate-pulse">
    <div className="aspect-[4/3] rounded-2xl bg-white/[0.04]" />
    <div className="mt-4 h-3 w-24 rounded bg-white/[0.06]" />
    <div className="mt-3 h-5 w-4/5 rounded bg-white/[0.06]" />
  </div>
);
